import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Config from "./common/Config";
import "./loginStyle.scss";
import InputTextField from "./components/textField/InputTextField";
import Button from "./components/button/Button";
import logo from "./images/siteLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { UserContext } from "./App";

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [showInvalid, setShowInvalid] = useState(false);
  const [showLoginFailure, setShowLoginFailure] = useState(false);
  const { setUser } = useContext(UserContext);

  const grant_type = "password";
  const [authError, setAuthError] = useState();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowInvalid(false);
    setShowLoginFailure(false);
    let errorsLocal = [];

    //email
    const expression = /\S+@\S+/;
    let validEmail = expression.test(String(username).toLowerCase());

    if (!validEmail) {
      errorsLocal.push("username");
    }

    if (errorsLocal.length > 0) {
      setShowInvalid(true);
      return false;
    }

    const res = await loginUser({
      username,
      password,
      grant_type,
    });

    //if username/password are invalid setShow(true);
    if (res) {
      setToken(res);
      await doesHaveAccess();
      navigate(`${process.env.REACT_APP_ORDER_FORM}/`);
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="">
        <div className="login">
          <div className="loginImg">
            <img src={logo} alt="logo" className="siteLogo" />
          </div>
          <div className="formContainer filedWidth">
            <form className="form" onSubmit={handleSubmit}>
              <div className="formTitle">
                <h2>Sign In</h2>
                <p>
                  
                </p>
              </div>
              {showInvalid && (
                <div className="alert">
                  <Alert severity="error" key="invalidValues">
                    Invalid email or password
                  </Alert>
                </div>
              )}
              {showLoginFailure && (
                <Alert key="loginFailed" severity="error">
                  {authError}
                </Alert>
              )}

              <div className="fields">
                <InputTextField
                  label="Email Address"
                  variant="outlined"
                  placeholder="Email Address"
                  type="text"
                  id="username"
                  onChange={(e) => setUserName(e.target.value)}
                />

                <InputTextField
                  label="Password"
                  variant="outlined"
                  placeholder="Enter your password"
                  type="password"
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="forgetPassword">
                <Link
                  to={Config.gatewayAccountUrl+"ForgotPassword"}
                >
                  <span> Forgot Password?</span>
                </Link>
              </div>

              <Button text="Login" type="submit" width="true" />

              <div className="register">
                <p>Don’t have an account?</p>
                <Link
                  to={Config.gatewayAccountUrl+"Register"}
                  className="registerText"
                >
                  <span> Register Now</span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <Container>
        <Jumbotron>
          <h5 className="centeredText">Login</h5>
        </Jumbotron>
        <Form className="centered" onSubmit={handleSubmit}>
          <Alert key="invalidValues" variant="danger" show={showInvalid}>
            Invalid email or password
          </Alert>
          <Alert key="loginFailed" variant="danger" show={showLoginFailure}>
            {authError}
          </Alert>
          <Form.Group controlId="username">
            <Form.Label>Email Address</Form.Label>
            <input
              type="text"
              id="username"
              className={
                hasError("username")
                  ? "form-control is-invalid"
                  : "form-control"
              }
              onChange={(e) => setUserName(e.target.value)}
            ></input>
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <input
              type="password"
              id="password"
              placeholder="Password"
              className={
                hasError("password")
                  ? "form-control is-invalid"
                  : "form-control"
              }
              onChange={(e) => setPassword(e.target.value)}
            ></input>
          </Form.Group>
          <Form.Group>
            <Button variant="primary" type="Submit">
              Login
            </Button>
            <Button
              variant="secondary"
              type="Link"
              href={Config.registerAccountUrl}
            >
              Register
            </Button>
          </Form.Group>
        </Form>
      </Container> */}
    </>
  );

  //Using https://www.digitalocean.com/community/tutorials/how-to-add-login-authentication-to-react-applications as a template for logging in
  async function loginUser(credentials) {
    try {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      };
      const res = await axios.post(
        Config.baseSecurityUrl + "Token",
        new URLSearchParams(credentials),
        config
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 400) {
        setAuthError(error.response.data.error_description);
      }
      setShowLoginFailure(true);
    }
  }

  async function doesHaveAccess() {
    let config = {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      },
    };
    await axios
      .get(
        Config.baseSecurityUrl +
          "api/v1/Account/VerifyAccessForRole?roleName=OrderForms.User",
        config
      )
      .then((response) => {
        if (response.data === null) {
          localStorage.clear();
        } else {
          setUser(response.data.EmailAddress);
          localStorage.setItem("accountNumber", response.data.CustomerNumber);
          localStorage.setItem("username", response.data.EmailAddress);

          if(response.data.CustomerNumber === '11111') {
            localStorage.setItem("internalAccount", true);
          }
        }
      })
      .catch((error) => {
        console.log("doesHaveAccess", error);
      });
  }

  // function hasError(key) {
  //   return errors.indexOf(key) !== -1;
  // }
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
